import {ERequestType} from "@gongt/ts-stl-library/request/request";
import {ApiResponse, ApiRequest} from "@gongt/ts-stl-library/request/protocol";

export const UserLogoutUrl = `/do_logout`;
export const UserLogoutMethod = ERequestType.TYPE_POST;

export interface UserLogoutBody extends ApiRequest {
	token: string;
}

export interface UserLogoutResponse extends ApiResponse {
}
